export default ({ axios }) => ({
    confirmAccount: (body) => axios.post(`/api/confirm-account`, body),
    login: (user) => axios.post(`/api/login`, user),
    logout: () => axios.post(`/api/logout`),
    passwordReset: (email) => axios.post(`/api/password-reset/${email}`),
    passwordConfirm: (body, configuration = {}) => axios.post(`/api/recover-password`, body, configuration)
})
